/* eslint-disable */
import AppContext, { AuthContext } from 'context/AppContext';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';

const CustomModal = ({ show, onHide, title, content, onDataChange }) => {
  const [childData, setChildData] = useState('');

  const handleColClick = (selectedCol) => {
    
    setChildData(selectedCol);
    onDataChange(selectedCol); // Parent'a veriyi iletiyoruz
    onHide();
  };



  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Row className="mb-3" > {/* Row'a 'mb-3' sınıfını ekleyerek rowlar arasındaki boşluğu artırır */}
        <Col style={{cursor: 'pointer'}} md={6} onClick={() => handleColClick('T1')} id='T1' >
          <div style={{display:'flex', alignItems: 'center',justifyContent: 'center', backgroundColor: 'lightgray', height: '150px', border: '4px double black', borderRadius: '8px', textAlign: 'center' }}>
            1
          </div>
        </Col>
        <Col md={6} onClick={() => handleColClick('T2')} style={{display: 'flex', flexDirection: 'row',cursor: 'pointer'}} id='T2'>
          <div style={{borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', backgroundColor: 'lightgray', height: '150px', border: "4px double black",width: '50%', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
            1
          </div>
          <div style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', border: '4px double black',backgroundColor: 'lightgray', height: '150px', width: '50%', textAlign: 'center',display:'flex', alignItems: 'center',justifyContent: 'center', }}>
            2
          </div>
        </Col>
      </Row>
      
      <Row className="mb-3"> {/* Row'a 'mb-3' sınıfını ekleyerek rowlar arasındaki boşluğu artırır */}
        <Col md={6} id='T3' onClick={() => handleColClick('T3')} style={{display: 'flex', flexDirection: 'row',cursor: 'pointer'}}>
          <div style={{borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', backgroundColor: 'lightgray',  height: '150px', border: "4px double black",width: '50%', display:'flex',textAlign: 'center',justifyContent: 'center', alignItems: 'center' }}>
            <p>1</p>
          </div>
          <div style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', border: '4px double black',backgroundColor: 'lightgray', height: '150px', width: '50%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1,width: '100%',borderBottom:'4px double black', height: 'auto',backgroundColor: 'lightgray', textAlign: 'center',display:'flex', alignItems: 'center',justifyContent: 'center',}}>
              2
            </div>
            <div style={{ borderTop: '4px double black', flex: 1,width: '100%',backgroundColor: 'lightgray', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
              3
            </div>
          </div>
        </Col>
        <Col md={6} id='T4' onClick={() => handleColClick('T4')} style={{display: 'flex', flexDirection: 'row',cursor: 'pointer'}}>
          <div style={{borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px',  border: '4px double black',backgroundColor: 'lightgray', height: '150px', width: '50%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ borderBottom: '4px double black', flex: 1,width: '100%', height: 'auto',backgroundColor: 'lightgray', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
              1
            </div>
            <div style={{ borderTop: '4px double black', flex: 1,width: '100%',backgroundColor: 'lightgray', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
              2
            </div>
          </div>
          <div style={{borderTopRightRadius: '8px', borderBottomRightRadius: '8px', backgroundColor: 'lightgray', height: '150px', border: "4px double black",width: '50%', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center', }}>
            3
          </div>
        </Col>
      </Row>

      {/* Ekstra Renkler */}
      <Row className="mb-3"> {/* Row'a 'mb-3' sınıfını ekleyerek rowlar arasındaki boşluğu artırır */}
      <Col md={6} onClick={() => handleColClick('T5')} id='T5' style={{display: 'flex', flexDirection: 'column',cursor: 'pointer'}}>
          <div style={{borderTopLeftRadius: '8px', borderTopRightRadius: '8px', backgroundColor: 'lightgray', height: '75px', border: "4px double black",width: '100%', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
            1
          </div>
          <div style={{ borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', border: '4px double black',backgroundColor: 'lightgray', height: '75px', width: '100%', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center', }}>
            2
          </div>
        </Col>
        <Col md={6} onClick={() => handleColClick('T6')} id='T6' style={{display: 'flex', flexDirection: 'column',cursor: 'pointer'}}>
          <div style={{borderTopLeftRadius: '8px', borderTopRightRadius: '8px', backgroundColor: 'lightgray', height: '75px', border: "4px double black",width: '100%', textAlign: 'center', display:'flex', alignItems: 'center',justifyContent: 'center',}}>
            1
          </div>
          <div style={{display: 'flex', flexDirection: 'row', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', border: '4px double black',backgroundColor: 'lightgray',height: '75px', width: '100%', textAlign: 'center',  }}>
          <div style={{borderRight: '4px double black',borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', backgroundColor: 'lightgray',height: '100%',width: '50%', textAlign: 'center',display:'flex', alignItems: 'center',justifyContent: 'center', }}>
            2
          </div>
          <div style={{ borderLeft: '4px double black',backgroundColor: 'lightgray', height: '100%', width: '50%', textAlign: 'center',display:'flex', alignItems: 'center',justifyContent: 'center', }}>
            3
          </div>
          </div>
        </Col>
      </Row>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
